module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=NO - Norway.28197674.svg";